import { parseParams } from '../util/NavigationUtil';
import RootStore from './RootStore';
import ContentStore from './ContentStore';

export interface GaData {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  submissionId?: number;
}

export interface GaDataParams {
  [key: string]: string;
}

export class GaDataStore {
  private contentStore: ContentStore;

  constructor(rootStore: RootStore) {
    this.contentStore = rootStore.contentStore;
  }

  public push(data: GaData) {
    if (window.dataLayer) {
      window.dataLayer.push(data);
    }
  }

  public static pushWithoutCmsData(data: GaData, params?: GaDataParams) {
    if (window.dataLayer) {
      const { eventCategory, eventLabel, eventAction } = data;
      const category = eventCategory && params ? parseParams(eventCategory, params) : eventCategory;
      const label = eventLabel && params ? parseParams(eventLabel, params) : eventLabel;
      const action = eventAction && params ? parseParams(eventAction, params) : eventAction;
      window.dataLayer.push({
        ...data,
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
      });
    }
  }

  public static pushOptimizelyEvent = (featureKey: string, variationKey: string) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ab-decision',
        'ab-featureKey': featureKey,
        'ab-variationKey': variationKey,
      });
    }
  };

  public pushWithTitle(data: GaData, title?: string, params?: GaDataParams) {
    data = {
      event: 'AutoEvent',
      ...data,
      eventCategory: this.getPageTitle(title),
    };
    GaDataStore.pushWithoutCmsData(data, params);
  }

  public getPageTitle(title?: string) {
    return `${title || this.getGaPageTitle()}`;
  }

  private getGaPageTitle() {
    return this.contentStore.currentPageContent.originalTitle || document.title;
  }
}

export default GaDataStore;
